import { ViewPoint } from '@magicore/visualize-3d';

/**
 * Convert a string to a Visualize3D ViewPort value
 * @param str case-insensitive string value
 * @returns The ViewPoint matching the string. If none match, returns ViewPoint.Front
 */
export const stringToViewPort = (str: string): ViewPoint => {
  if (!str) {
    return ViewPoint.Front;
  }

  const lowerCased = str.toLowerCase();

  switch (lowerCased) {
    case 'topleft':
      return ViewPoint.TopLeft;
    case 'topright':
      return ViewPoint.TopRight;
    case 'top':
      return ViewPoint.Top;
    case 'left':
      return ViewPoint.Left;
    case 'right':
      return ViewPoint.Right;
    case 'front':
      return ViewPoint.Front;
    case 'back':
      return ViewPoint.Back;
    case 'bottom':
      return ViewPoint.Bottom;
    default:
      return ViewPoint.Front;
  }
};
